import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, take, tap } from 'rxjs/operators';
import { HttpService } from './http.service';
import { AuthInfo, RegistrationRequest, UserAuth, UserInfo } from '../type/auth.interface';
import { DictionaryService } from './dictionary.service';
import { environment } from '../../environments/environment';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root'
})
export class KioskIdService {
  kioskID: any = undefined;

  constructor(private router: Router,
              private route: ActivatedRoute) {
  }

  getKioskId() {
    this.kioskID = localStorage.getItem('kiosk');
    if (!this.kioskID) {
      this.route.queryParams.pipe(filter((params) => {
        return params['kiosk']
      }), take(1)).subscribe(params => {
          this.kioskID = params['kiosk'];
          localStorage.setItem('kiosk', params['kiosk']);
      });
    }
    return localStorage.getItem('kiosk')
  }
}
